//@flow
import React from "react";

import { Spinner } from "@quantum/ui";

import { ErroCarregamento } from "../../comum";

import { useTemplateMedidas } from "../../remote";

import { type ActionCreator } from "../../../state";

import "./lista-templates-medidas.css";

type Props = {
  handleSelecionarArquivo: any => any,
  abrirTemplate: ActionCreator,
};

function ListaTemplateMedidas({
  handleSelecionarArquivo,
  abrirTemplate,
}: Props) {
  const {
    data: listaArquivos = [],
    failed,
    loading,
    fetchData,
  } = useTemplateMedidas();

  const handleArquivoClick = event => {
    handleSelecionarArquivo(listaArquivos[event.target.id]);
  };

  if (loading) {
    return (
      <div className="ListaTemplateMedidas">
        <div className="ListaTemplateMedidas__spinner">
          <Spinner />
        </div>
      </div>
    );
  } else if (failed) {
    return <ErroCarregamento retry={fetchData} />;
  }

  return (
    <div className="ListaTemplateMedidas">
      <table className="ListaTemplateMedidas__tabela">
        <tbody>
          {listaArquivos.map((arquivo, index) => {
            return (
              <tr
                key={index}
                className="ListaTemplateMedidas__linha"
                onClick={handleArquivoClick}
              >
                <td id={index} className="ListaTemplateMedidas__celula">
                  {arquivo.nome}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ListaTemplateMedidas;
